import React from 'react';

// Game-style SVG Icons for Student Dashboard
export const GameIcons = {
  // Star icon for achievements and ratings
  Star: ({ className = '', size = 24, color = '#FFD700' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill={color}
      className={`game-icon ${className}`}
    >
      <path d="M12,1.5l2.61,6.727l6.89,0.53l-5.278,4.688l1.65,7.055l-5.872-3.753l-5.872,3.753l1.65-7.055l-5.278-4.688l6.89-0.53l2.61-6.727z" 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
    </svg>
  ),
  
  // Trophy icon for achievements
  Trophy: ({ className = '', size = 24, color = '#FFD700' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill={color}
      className={`game-icon ${className}`}
    >
      <path d="M5,3h14c0.6,0,1,0.4,1,1v3c0,3.3-2.7,6-6,6h-4c-3.3,0-6-2.7-6-6v-3c0-0.6,0.4-1,1-1z" 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
      <path d="M8,14v4h8v-4" 
        stroke="#FFA000" 
        strokeWidth="1" 
        fill="none" 
      />
      <path d="M7,21h10c0.6,0,1-0.4,1-1v-1c0-0.6-0.4-1-1-1h-10c-0.6,0-1,0.4-1,1v1c0,0.6,0.4,1,1,1z" 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
    </svg>
  ),
  
  // Play button for continue learning
  Play: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill={color} />
      <path d="M16,12l-6,4v-8l6,4z" fill="white" />
    </svg>
  ),
  
  // Book icon for learning
  Book: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M4,4v14c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4z" 
        fill={color} 
        stroke="#1565C0" 
        strokeWidth="1" 
      />
      <path d="M12,2v18" stroke="#1565C0" strokeWidth="1" fill="none" />
      <path d="M9,6h-3" stroke="white" strokeWidth="1" />
      <path d="M9,9h-3" stroke="white" strokeWidth="1" />
      <path d="M9,12h-3" stroke="white" strokeWidth="1" />
      <path d="M18,6h-3" stroke="white" strokeWidth="1" />
      <path d="M18,9h-3" stroke="white" strokeWidth="1" />
      <path d="M18,12h-3" stroke="white" strokeWidth="1" />
    </svg>
  ),
  
  // Target/Goal icon
  Target: ({ className = '', size = 24, color = '#F44336' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth="2" />
      <circle cx="12" cy="12" r="6" fill="none" stroke={color} strokeWidth="2" />
      <circle cx="12" cy="12" r="2" fill={color} />
    </svg>
  ),
  
  // Medal icon
  Medal: ({ className = '', size = 24, color = '#FFD700' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="8" fill={color} stroke="#FFA000" strokeWidth="1" />
      <circle cx="12" cy="12" r="5" fill="#FFC107" stroke="#FFA000" strokeWidth="1" />
      <path d="M12,4v-2" stroke="#FFA000" strokeWidth="2" strokeLinecap="round" />
      <path d="M12,22v-2" stroke="#FFA000" strokeWidth="2" strokeLinecap="round" />
      <path d="M4,12h-2" stroke="#FFA000" strokeWidth="2" strokeLinecap="round" />
      <path d="M22,12h-2" stroke="#FFA000" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  
  // Rocket icon for progress
  Rocket: ({ className = '', size = 24, color = '#9C27B0' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M12,2c-5,0-9,4-9,9v7c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-7C21,6,17,2,12,2z" 
        fill={color} 
        stroke="#7B1FA2" 
        strokeWidth="1" 
      />
      <path d="M12,2v8" stroke="#7B1FA2" strokeWidth="1" />
      <path d="M8,10h8" stroke="#7B1FA2" strokeWidth="1" />
      <path d="M9,16l-3,4" stroke="#7B1FA2" strokeWidth="1" />
      <path d="M15,16l3,4" stroke="#7B1FA2" strokeWidth="1" />
    </svg>
  ),
  
  // Lightning bolt for quick actions
  Lightning: ({ className = '', size = 24, color = '#FFC107' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M13,2l-10,12h6v8l10-12h-6v-8z" 
        fill={color} 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
    </svg>
  ),
  
  // Crown icon for leaderboard
  Crown: ({ className = '', size = 24, color = '#FFD700' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M3,17l2-9l5,3l2-7l2,7l5-3l2,9h-18z" 
        fill={color} 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
      <path d="M5,20h14v2h-14z" 
        fill={color} 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
    </svg>
  ),
  
  // Chart icon for statistics
  Chart: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M4,4v16h16" stroke={color} strokeWidth="2" fill="none" />
      <path d="M7,16l4-4l3,3l5-5" stroke={color} strokeWidth="2" fill="none" />
      <circle cx="7" cy="16" r="1.5" fill={color} />
      <circle cx="11" cy="12" r="1.5" fill={color} />
      <circle cx="14" cy="15" r="1.5" fill={color} />
      <circle cx="19" cy="10" r="1.5" fill={color} />
    </svg>
  ),

  // Character boy
  CharacterBoy: ({ className = '', size = 40 }: { className?: string, size?: number }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      className={`game-icon ${className}`}
    >
      <circle cx="20" cy="12" r="8" fill="#FFB74D" />
      <path d="M12,26c0-4.4,3.6-8,8-8s8,3.6,8,8v10h-16v-10z" fill="#2196F3" />
      <circle cx="16" cy="11" r="1.5" fill="#5D4037" />
      <circle cx="24" cy="11" r="1.5" fill="#5D4037" />
      <path d="M17,15c1,1,5,1,6,0" stroke="#5D4037" strokeWidth="1" fill="none" strokeLinecap="round" />
      <path d="M14,8c2-3,10-3,12,0" stroke="#8D6E63" strokeWidth="1.5" fill="none" />
    </svg>
  ),
  
  // Character girl
  CharacterGirl: ({ className = '', size = 40 }: { className?: string, size?: number }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      className={`game-icon ${className}`}
    >
      <circle cx="20" cy="12" r="8" fill="#FFCCBC" />
      <path d="M12,26c0-4.4,3.6-8,8-8s8,3.6,8,8v10h-16v-10z" fill="#F48FB1" />
      <circle cx="16" cy="11" r="1.5" fill="#5D4037" />
      <circle cx="24" cy="11" r="1.5" fill="#5D4037" />
      <path d="M17,15c1,1,5,1,6,0" stroke="#5D4037" strokeWidth="1" fill="none" strokeLinecap="round" />
      <path d="M12,12c0-6,16-6,16,0" stroke="#8D6E63" strokeWidth="1.5" fill="none" />
    </svg>
  ),
  
  // Character fox (mascot)
  Fox: ({ className = '', size = 40 }: { className?: string, size?: number }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      className={`game-icon ${className}`}
    >
      <path d="M20,4l-8,8l-2,10l4,8h12l4-8l-2-10z" fill="#FF9800" />
      <path d="M14,14l-2,4l2,6l6,2l6-2l2-6l-2-4z" fill="#FFECB3" />
      <circle cx="16" cy="16" r="1.5" fill="#5D4037" />
      <circle cx="24" cy="16" r="1.5" fill="#5D4037" />
      <path d="M18,20h4" stroke="#5D4037" strokeWidth="1" />
      <path d="M12,12l-4-4" stroke="#FF9800" strokeWidth="1.5" fill="none" />
      <path d="M28,12l4-4" stroke="#FF9800" strokeWidth="1.5" fill="none" />
      <path d="M20,22v2" stroke="#5D4037" strokeWidth="1" />
    </svg>
  ),
  
  // User icon for profile
  User: ({ className = '', size = 24, color = '#FFFFFF' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="8" r="4" fill={color} />
      <path d="M20,19c0-4.4-3.6-8-8-8s-8,3.6-8,8" fill="none" stroke={color} strokeWidth="2" />
    </svg>
  ),
  
  // Check icon for completed items
  Check: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M9,16.17L4.83,12l-1.42,1.41L9,19L21,7l-1.41-1.41L9,16.17z" fill={color} />
    </svg>
  ),
  
  // ChevronLeft icon for navigation
  ChevronLeft: ({ className = '', size = 24, color = '#6366F1' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M15.41,7.41L14,6l-6,6l6,6l1.41-1.41L10.83,12L15.41,7.41z" fill={color} />
    </svg>
  ),
  
  // ChevronRight icon for navigation
  ChevronRight: ({ className = '', size = 24, color = '#4B5563' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M10,6L8.59,7.41L13.17,12L8.59,16.59L10,18l6-6L10,6z" fill={color} />
    </svg>
  ),
  
  // Lock icon for locked items
  Lock: ({ className = '', size = 24, color = '#9CA3AF' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M18,8h-1V6c0-2.76-2.24-5-5-5S7,3.24,7,6v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10C20,8.9,19.1,8,18,8z M9,6c0-1.66,1.34-3,3-3s3,1.34,3,3v2H9V6z M18,20H6V10h12V20z M12,17c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C10,16.1,10.9,17,12,17z" fill={color} />
    </svg>
  ),
  
  // CheckCircle icon for completed tasks
  CheckCircle: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z" fill={color} />
      <path d="M16.59,7.58L10,14.17l-2.59-2.58L6,13l4,4l8-8L16.59,7.58z" fill={color} />
    </svg>
  ),
  
  // Calendar icon for streaks and dates
  Calendar: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M19,3h-1V1h-2v2H8V1H6v2H5C3.89,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V8h14V19z" fill={color} />
      <path d="M7,10h5v5H7V10z" fill={color} />
    </svg>
  ),
  // LightBulb icon for tips and hints
  LightBulb: ({ className = '', size = 24, color = '#FFC107' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M12,2C7.86,2,4.5,5.36,4.5,9.5c0,3.15,2.01,5.83,4.8,6.84c0,0.23,0,0.45,0,0.66c0,0.41,0.17,0.79,0.44,1.06c0.27,0.27,0.65,0.44,1.06,0.44h2.4c0.41,0,0.79-0.17,1.06-0.44c0.27-0.27,0.44-0.65,0.44-1.06c0-0.22,0-0.45,0-0.66c2.79-1.01,4.8-3.69,4.8-6.84C19.5,5.36,16.14,2,12,2z" 
        fill={color} 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
      <path d="M10,20h4v1c0,0.55-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1V20z" 
        fill={color} 
        stroke="#FFA000" 
        strokeWidth="1" 
      />
    </svg>
  ),
  
  // ChartBar icon for statistics view
  ChartBar: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M4,20V4h2v16H4z" fill={color} />
      <path d="M18,20V10h2v10H18z" fill={color} />
      <path d="M11,20V8h2v12H11z" fill={color} />
      <path d="M3,4h18v2H3V4z" fill={color} />
      <path d="M3,18h18v2H3V18z" fill={color} />
    </svg>
  ),
  
  // CloudCheck icon for auto-save
  CloudCheck: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M19.35,10.04C18.67,6.59,15.64,4,12,4C9.11,4,6.6,5.64,5.35,8.04C2.34,8.36,0,10.91,0,14c0,3.31,2.69,6,6,6h13c2.76,0,5-2.24,5-5C24,12.36,21.95,10.22,19.35,10.04z" 
        fill="#BBDEFB" 
        stroke="#2196F3" 
        strokeWidth="1" 
      />
      <path d="M9,16.17L6.53,13.7L5.47,14.76L9,18.29L17.53,9.76L16.47,8.7L9,16.17z" 
        fill={color} 
      />
    </svg>
  ),
  
  // RefreshCw icon for restart/retry
  RefreshCw: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M17.65,6.35C16.2,4.9,14.21,4,12,4c-4.42,0-7.99,3.58-7.99,8s3.57,8,7.99,8c3.73,0,6.84-2.55,7.73-6h-2.08c-0.82,2.33-3.04,4-5.65,4c-3.31,0-6-2.69-6-6s2.69-6,6-6c1.66,0,3.14,0.69,4.22,1.78L13,11h7V4L17.65,6.35z"
        fill="none"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  ),
  
  // Home icon for dashboard navigation
  Home: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M10,20v-6h4v6h5v-8h3L12,3L2,12h3v8H10z"
        fill={color}
        stroke="#1565C0"
        strokeWidth="1"
      />
    </svg>
  ),

  // Question icon for quiz questions
  Question: ({ className = '', size = 24, color = '#673AB7' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2" />
      <path d="M12,17L12,17" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M12,7v5" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),

  // ArrowRight icon
  ArrowRight: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M12,4l8,8l-8,8" stroke={color} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4,12h16" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),

  // X icon for incorrect answers
  X: ({ className = '', size = 24, color = '#F44336' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M18,6L6,18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6,6L18,18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  // AlertTriangle icon for warnings
  AlertTriangle: ({ className = '', size = 24, color = '#FF9800' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M10.29,3.86L1.82,18a2,2,0,0,0,1.71,3h16.94a2,2,0,0,0,1.71-3L13.71,3.86a2,2,0,0,0-3.42,0z" 
        fill="none" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
      <path d="M12,9v4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12,17L12,17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  // Gamepad icon for games
  Gamepad: ({ className = '', size = 24, color = '#9C27B0' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M6,12h4m-2-2v4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.5,11.5a1,1,0,1,1-1-1A1,1,0,0,1,16.5,11.5z" fill={color} />
      <path d="M18.5,14.5a1,1,0,1,1-1-1A1,1,0,0,1,18.5,14.5z" fill={color} />
      <path d="M21,12c0,1.66-1.34,3-3,3h-1.17C15.45,15,14.26,15.5,13.41,16.35L12,17.76l-1.41-1.41C9.74,15.5,8.55,15,7.17,15H6c-1.66,0-3-1.34-3-3V8c0-1.66,1.34-3,3-3h1.17C8.55,5,9.74,4.5,10.59,3.65L12,2.24l1.41,1.41C14.26,4.5,15.45,5,16.83,5H18c1.66,0,3,1.34,3,3V12z" 
        fill="none" 
        stroke={color} 
        strokeWidth="2" 
      />
    </svg>
  ),

  // Clock icon for timer
  Clock: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth="2" />
      <path d="M12,6L12,12L16,14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  // Info icon for information
  Info: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth="2" />
      <path d="M12,16L12,12" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M12,8L12,8" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),

  // Pause icon for pause button
  Pause: ({ className = '', size = 24, color = '#FF9800' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill={color} />
      <path d="M10,8L10,16" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M14,8L14,16" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),

  // VolumeUp icon for sound control
  VolumeUp: ({ className = '', size = 24, color = '#2196F3' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M3,9v6h4l5,5V4L7,9H3z" fill={color} />
      <path d="M16.5,12c0-1.77-1.02-3.29-2.5-4.03v8.05C15.48,15.29,16.5,13.77,16.5,12z" fill={color} fillOpacity="0.8" />
      <path d="M14,3.23v2.06c2.89,0.86,5,3.54,5,6.71s-2.11,5.85-5,6.71v2.06c4.01-0.91,7-4.49,7-8.77S18.01,4.14,14,3.23z" fill={color} fillOpacity="0.6" />
    </svg>
  ),

  // Flag icon for completion
  Flag: ({ className = '', size = 24, color = '#4CAF50' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M4,15h11l1-2l-1-2h-6l-1-2h-4v14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M4,21L4,21" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  // Video icon for learning videos
  Video: ({ className = '', size = 24, color = '#4F46E5' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <rect x="2" y="4" width="20" height="16" rx="2" ry="2" fill="none" stroke={color} strokeWidth="2" />
      <path d="M10,8L16,12L10,16L10,8z" fill={color} />
    </svg>
  ),

  // PlayCircle icon for video player
  PlayCircle: ({ className = '', size = 24, color = '#FFFFFF' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <circle cx="12" cy="12" r="10" fill="none" stroke={color} strokeWidth="2" />
      <path d="M10,8L16,12L10,16L10,8z" fill={color} />
    </svg>
  ),

  // ClosedCaption icon for video subtitles
  ClosedCaption: ({ className = '', size = 24, color = '#FFFFFF' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <rect x="2" y="6" width="20" height="12" rx="2" ry="2" fill="none" stroke={color} strokeWidth="2" />
      <path d="M7,12.5a1.5,1.5 0 1,1 0,-3h2.5" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M14.5,12.5a1.5,1.5 0 1,1 0,-3h2.5" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),

  // FullScreen icon for video player
  FullScreen: ({ className = '', size = 24, color = '#FFFFFF' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M8,3L3,3L3,8" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21,8L21,3L16,3" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3,16L3,21L8,21" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16,21L21,21L21,16" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  // FastForward icon for skipping video
  FastForward: ({ className = '', size = 24, color = '#4F46E5' }: { className?: string, size?: number, color?: string }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={`game-icon ${className}`}
    >
      <path d="M13,6L19,12L13,18L13,6z" fill={color} />
      <path d="M5,6L11,12L5,18L5,6z" fill={color} />
    </svg>
  )
};

export default GameIcons;
